export default "__VITE_ASSET__CWINwtKA__"